import { useState, useRef, useEffect, useId } from 'react';
import 'swiper/css';
import { YoutubeCover } from '../../youtube-cover';

const VideoCustom = ({ item }) => {
  const playerRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const videoId = useId();

  useEffect(() => {
    const handlePause = (event) => {
      if (event.detail?.playingVideoId !== videoId && playerRef.current) {
        playerRef.current.pause();
      }
    };

    window.addEventListener('pauseAllVideos', handlePause);
    return () => window.removeEventListener('pauseAllVideos', handlePause);
  }, [videoId]);

  const broadcastPlay = () => {
    window.dispatchEvent(
      new CustomEvent('pauseAllVideos', { detail: { playingVideoId: videoId } })
    );
  };

  const handleClick = () => {
    setIsActive((current) => !current);
    broadcastPlay();
    if (playerRef != null) {
      playerRef.current.play();
    }
  };

  const mediaItemUrl = item?.video?.node?.mediaItemUrl;
  const imageSourceUrl = item?.image?.node.sourceUrl;

  if (!mediaItemUrl) {
    return <div>no video</div>;
  }

  return (
    <div className="videoWrapper">
      {item?.image?.node?.sourceUrl && (
        <YoutubeCover coverImage={item?.image?.node?.sourceUrl} handleClick={handleClick} isActive={isActive} />
      )}
      <video
        className="youtubeVideo"
        controls
        poster={imageSourceUrl}
        ref={playerRef}
        onPlay={broadcastPlay}
      >
        <source src={mediaItemUrl} type="video/mp4" />
        Twoja przeglądarka nie wspiera video.
      </video>
    </div>
  );
};
export default VideoCustom;